import { Box, Chip } from '@mui/material';

import { USER_APPROVE_STATUS, USER_QUALIFY_STATUS } from '@/config/constants';
import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { shouldShowUserLoanStatusChips } from './userLoanStatus';

/**
 * Mirrors the user qualify/approve chips in {@link ProductBadges} for loan hub
 * pages and deal-room progress (same Chip label, color, and icon).
 */
export function UserLoanStatusChips() {
  const { data: user } = useGetCurrentUserQuery();
  if (!shouldShowUserLoanStatusChips(user)) return null;

  const isUserApproved =
    user!.approveStatus === USER_APPROVE_STATUS.APPROVED &&
    Boolean(user!.approvalAmount);
  const isUserQualified = user!.qualifyStatus === USER_QUALIFY_STATUS.QUALIFY;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        justifyContent: 'flex-end',
      }}
    >
      {!isUserApproved && isUserQualified ? (
        <Chip
          label="Qualified"
          size="small"
          color="success"
          icon={<i className="fa-light fa-circle-o" />}
        />
      ) : null}
      {isUserApproved ? (
        <Chip
          label="Approved"
          size="small"
          color="success"
          icon={<i className="fa-light fa-circle-o" />}
        />
      ) : null}
    </Box>
  );
}
